import { logAndToast } from './logAndToast';
import type { LogHelper } from '@types';

export const logInfo: LogHelper = async (
  message,
  source,
  context,
  showToast = false,
  forceLog = false
): Promise<void> => {
  await logAndToast({
    message,
    source,
    context,
    toast: showToast,
    level: 'info',
    forceLog
  });
};
